import ContactForm from "../components/ContactForm";
import { Mail, Globe, DollarSign, MessageSquare } from "lucide-react";

function ContactPage() {
  return (
    <>
      <section className="bg-primary text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl font-bold mb-6">Contact Us</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Interested in acquiring this premium domain? Fill out the form below
            and we'll get back to you promptly.
          </p>
        </div>
      </section>
      <section className="bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <ContactForm />
            </div>

            <div>
              <div className="bg-gray-50 mt-10 p-8 rounded-lg mb-8">
                <h2 className="text-2xl font-bold mb-6">Contact Information</h2>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <Mail className="h-6 w-6 text-primary mr-4 mt-1" />
                    <div>
                      <h3 className="font-semibold">Email</h3>
                      <p className="text-gray-600">info@wholefoods.ai</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <Globe className="h-6 w-6 text-primary mr-4 mt-1" />
                    <div>
                      <h3 className="font-semibold">Website</h3>
                      <p className="text-gray-600">wholefoods.ai</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-secondary text-white p-8 rounded-lg">
                <h2 className="text-2xl font-bold mb-6">
                  Why Invest in WholeFoods.ai?
                </h2>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <DollarSign className="h-6 w-6 text-accent mr-4 mt-1" />
                    <div>
                      <h3 className="font-semibold">High-Value Investment</h3>
                      <p className="text-gray-200">
                        Premium domain in a rapidly growing market sector.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <Globe className="h-6 w-6 text-accent mr-4 mt-1" />
                    <div>
                      <h3 className="font-semibold">Brand Recognition</h3>
                      <p className="text-gray-200">
                        Instantly recognizable and memorable domain name.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <MessageSquare className="h-6 w-6 text-accent mr-4 mt-1" />
                    <div>
                      <h3 className="font-semibold">Market Positioning</h3>
                      <p className="text-gray-200">
                        Position yourself at the forefront of AI in food tech.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section bg-gray-50">
        <div className="container-custom">
          <h2 className="text-3xl font-bold mb-12 text-center">
            Frequently Asked Questions
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-bold mb-3">
                What is the asking price for WholeFoods.ai?
              </h3>
              <p className="text-gray-600">
                The domain is priced based on its market value and potential.
                Please contact us for current pricing information.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-bold mb-3">
                Is the domain currently in use?
              </h3>
              <p className="text-gray-600">
                The domain currently hosts this informational website to
                showcase its potential applications and value.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-bold mb-3">
                How is the transfer process handled?
              </h3>
              <p className="text-gray-600">
                We use a secure escrow service to ensure a safe and smooth
                transfer process for both parties.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-bold mb-3">
                Are there any legal restrictions on using this domain?
              </h3>
              <p className="text-gray-600">
                While the domain itself has no inherent restrictions, buyers
                should be aware of trademark considerations when using
                "WholeFoods" in their branding.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactPage;
